module.exports = __webpack_public_path__ + "static/media/image_05.6780d7aa.jpg";